<template>
	<div>
		<div id="main-text">
			<span>設置現場マスタ</span>
		</div>
        <button class="export" @click="getLocationMasterCsv()">
            エクスポート
        </button>
		<div id="main-contents">
			<div id="list-contents">
				<table class="list-table">
					<tr class="list-table-header">
						<th>取引先名</th>
						<th>設置現場名</th>
						<th>電話番号</th>
						<th>住所</th>
					</tr>
				</table>
				<div class="list-table-scroller">
					<table class="list-table-contents">
						<template v-if="locationMasterList !== null">
							<template v-for="(item, index) in locationMasterList.location">
								<tr class="list-table-row" :key="'location_' + index" @click="toUpdate(item.id)">
									<td>
										<span v-if="item.customer_id === null || item.customer_id === ''" v-tooltip="'-'">-</span>
										<template v-else>
											<span v-if="customerMasterApiStatus" v-tooltip="getCustomerNameById(item.customer_id)">{{ getCustomerNameById(item.customer_id) }}</span>
										</template>
									</td>
									<td>
										<span v-if="item.name === null || item.name === ''" v-tooltip="'-'">-</span>
										<span v-else v-tooltip="item.name">{{ item.name }}</span>
									</td>
									<td>
										<span v-if="item.phone_number === null || item.phone_number === ''" v-tooltip="'-'">-</span>
										<span v-else v-tooltip="item.phone_number">{{ item.phone_number }}</span>
									</td>
									<td>
										<span v-if="item.address === null || item.address === ''" v-tooltip="'-'">-</span>
										<span v-else v-tooltip="item.address">{{ item.address }}</span>
									</td>
								</tr>
							</template>
						</template>
					</table>
				</div>
				<div class="pager" v-if="page_num !== 0">
					<template v-if="current_page !== 1">
						<span class="page" @click="pager(current_page - 1)">
							<img src="../assets/img/left_arrow.png">
						</span>
					</template>
					<template v-else>
						<span class="page" style="background-color: #BCBCCB;">
							<img src="../assets/img/left_arrow.png">
						</span>
					</template>
					<template v-if="page_num < 5">
						<template v-for="page in page_num">
							<span :class="{'page': true, 'current': current_page === page}" :key="'page_' + page" @click="pager(page)">
								<span>{{ page }}</span>
							</span>
						</template>
					</template>
					<template v-else>
						<template v-if="current_page < 4">
							<span :class="{'page': true, 'current': current_page === 1}" @click="pager(1)">
								<span>{{ 1 }}</span>
							</span>
							<span :class="{'page': true, 'current': current_page === 2}" @click="pager(2)">
								<span>{{ 2 }}</span>
							</span>
							<span :class="{'page': true, 'current': current_page === 3}" @click="pager(3)">
								<span>{{ 3 }}</span>
							</span>
							<span :class="{'page': true, 'current': current_page === 4}" @click="pager(4)">
								<span>{{ 4 }}</span>
							</span>
							<span :class="{'page': true, 'current': current_page === 5}" @click="pager(5)">
								<span>{{ 5 }}</span>
							</span>
						</template>
						<template v-else-if="(current_page + 2) <= page_num">
							<span class="page" @click="pager(current_page - 2)">
								<span>{{ current_page - 2 }}</span>
							</span>
							<span class="page" @click="pager(current_page - 1)">
								<span>{{ current_page - 1 }}</span>
							</span>
							<span class="page current">
								<span>{{ current_page }}</span>
							</span>
							<span class="page" @click="pager(current_page + 1)">
								<span>{{ current_page + 1 }}</span>
							</span>
							<span class="page" @click="pager(current_page + 2)">
								<span>{{ current_page + 2 }}</span>
							</span>
						</template>
						<template v-else-if="(current_page + 1) <= page_num">
							<span class="page" @click="pager(current_page - 3)">
								<span>{{ current_page - 3 }}</span>
							</span>
							<span class="page" @click="pager(current_page - 2)">
								<span>{{ current_page - 2 }}</span>
							</span>
							<span class="page" @click="pager(current_page - 1)">
								<span>{{ current_page - 1 }}</span>
							</span>
							<span class="page current">
								<span>{{ current_page }}</span>
							</span>
							<span class="page" @click="pager(current_page + 1)">
								<span>{{ current_page + 1 }}</span>
							</span>
						</template>
						<template v-else-if="current_page === page_num">
							<span class="page" @click="pager(current_page - 4)">
								<span>{{ current_page - 4 }}</span>
							</span>
							<span class="page" @click="pager(current_page - 3)">
								<span>{{ current_page - 3 }}</span>
							</span>
							<span class="page" @click="pager(current_page - 2)">
								<span>{{ current_page - 2 }}</span>
							</span>
							<span class="page" @click="pager(current_page - 1)">
								<span>{{ current_page - 1 }}</span>
							</span>
							<span class="page current">
								<span>{{ current_page }}</span>
							</span>
						</template>
					</template>
					<template v-if="current_page !== page_num">
						<span class="page" @click="pager(current_page + 1)">
							<img src="../assets/img/right_arrow.png">
						</span>
					</template>
					<template v-else>
						<span class="page" style="background-color: #BCBCCB;">
							<img src="../assets/img/right_arrow.png">
						</span>
					</template>
				</div>
			</div>
			<div class="contents-filter">
				<div class="contents">
					<div class="filter-title">
						詳細検索
					</div>
					<div class="filter">
						<div class="title">
							取引先名
						</div>
						<div class="input">
                            <v-select :options="options_customer" v-model="customer_name">
								<template #no-options>データが存在しません</template>
							</v-select>
						</div>
					</div>
					<div class="filter">
						<div class="title">
							設置現場名
						</div>
						<div class="input">
							<v-select :options="options_location" v-model="filter_params.name">
								<template #no-options>データが存在しません</template>
							</v-select>
						</div>
					</div>
                    <div class="filter">
						<div class="title">
							電話番号
						</div>
						<div class="input">
							<input type="tel" pattern="[\d\-]*" placeholder="電話番号" maxlength="15" v-model="filter_params.phone_number">
						</div>
					</div>
                    <div class="filter">
						<div class="title">
							住所
						</div>
						<div class="input">
							<input type="text" placeholder="住所" maxlength="200" v-model="filter_params.address">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="buttons">
			<router-link to="location_master_regist">
				<button class="button-next">新規登録</button>
			</router-link>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
export default {
	components: {
		vSelect,
	},
	data() {
		return {
			filter_params: {
				customer_name: null,
				name: null,
				phone_number: null,
				address: null,
			},
			customer_name: null,
			page_num: 0,
			current_page: 1,
			page_start: 1,
			page_end: 1,
			options_customer: [],
			options_location: [],
			flags: {
				location: false,
				customer: false,
			}
		}
	},
	created() {
		// 関連ページからの復帰で検索条件を保持
		if (this.locationMasterFilterParams !== null) {
			this.filter_params = this.locationMasterFilterParams
		}
		// リロード時にページを保持するように
		let params = this.filter_params
		params.page = 1
		if (this.$route.query.page !== undefined) {
			this.current_page = Number(this.$route.query.page)
			params.page = this.current_page
		}
		this.getCustomerMasterList(params)
		this.getFilterLocationList(null, params)
	},
	mounted() {

	},
	methods: {
		// 表示用取引先マスタ取得
		async getCustomerMasterList(params) {
			this.$store.dispatch('loading/startLoad')
				.then(async () => {
					await this.$store.dispatch('customerMaster/getCustomerMasterApi', null)
					if (this.customerMasterApiStatus) {
						this.customerMasterList.list.filter(item => {
							if (item.floor !== "") {
								this.options_customer.push(item.floor)
							}
						})
						this.flags.customer = true
						if (this.flags.customer && this.flags.location) {
							this.getLocationMasterList(params)
						}
					}
				})
		},
		// 設置現場マスタ一覧取得
		async getLocationMasterList(params) {
			this.$store.dispatch('loading/startLoad')
				.then(async () => {
					await this.$store.dispatch('locationMaster/getLocationMasterApi', params)
					if (this.locationMasterApiStatus) {
						if (this.locationMasterList.page !== undefined) {
							this.page_num = this.locationMasterList.page

							// 最大ページ数が最大表示数の5を上回っていた場合
							if (this.page_num > 5) {
								this.page_start = this.current_page - 2 < 0 ? 1 : this.current_page - 2
								this.page_end = this.page_end > this.current_page + 2 ? this.page_num : this.page_end > this.current_page + 2
							}
							else {
								this.page_start = 1
								this.page_end = this.page_num
							}
						}
					}
				})
				.then(() => this.$store.dispatch('loading/endLoad'))
		},
		// CSVダウンロード
		async getLocationMasterCsv() {
			const params = {
				customer_name: this.filter_params.floor,
				phone_number: this.filter_params.phone_number,
				fax_number: this.filter_params.fax_number,
				address: this.filter_params.address,
				deadline: this.filter_params.deadline
			}
			this.$store.dispatch('loading/startLoad')
				.then(async () => {
					await this.$store.dispatch('locationMaster/getLocationMasterCsvApi', params)
				})
				.then(() => this.$store.dispatch('loading/endLoad'))
		},
		// 更新画面へ
		toUpdate(id) {
			this.$router.push('location_master_update?page=' + this.current_page + '&id=' + id)
		},
		// ページ切り替え
		pager(page) {
			this.$router.push('location_master?page=' + page)
			this.current_page = page
			let params = this.filter_params
			params.page = this.current_page
			this.getLocationMasterList(params)
		},
		// 取引先IDから取引先名を取得する
		getCustomerNameById(id) {
			let result = ""
			this.customerMasterList.list.filter(item => {
				if (item.id === id) {
					result = item.floor
				}
			})
			return result
		},
		// 検索用事業所一覧取得
		getFilterLocationList(name = null, params = null) {
			this.$store.dispatch('loading/startLoad')
                .then(() => this.$store.dispatch('locationMaster/getFilterLocationMasterApi', {customer_name: name}))
                .then(() => {
					this.options_location.splice(0, this.options_location.length)
					this.filterLocationMasterList.location.filter(item => {
						if (item.name !== "") {
							this.options_location.push(item.name)
						}
					})
					if (params !== null) {
						this.flags.location = true
						if (this.flags.customer && this.flags.location) {
							this.getLocationMasterList(params)
						}
					}
					else {
						this.$store.dispatch('loading/endLoad')
					}
				})
		},
	},
	computed: {
		...mapState({
			locationMasterApiStatus: state => state.locationMaster.apiStatus,
			locationMasterList: state => state.locationMaster.locationMasterList,
			locationMasterFilterParams: state => state.locationMaster.filterParams,
			filterLocationMasterList: state => state.locationMaster.filterLocationMasterList,
			customerMasterApiStatus: state => state.customerMaster.apiStatus,
			customerMasterList: state => state.customerMaster.customerMasterList,
		})
	},
	watch: {
		// 検索結果取得
		filter_params: {
			handler(value) {
				let params = value
				params.page = 1
				this.current_page = 1
				this.page_num = 0
				this.getLocationMasterList(params)
				this.$store.commit('locationMaster/setFilterParams', value)
			},
			deep : true,
		},
		customer_name(value) {
			this.filter_params.customer_name = value
			this.getFilterLocationList(value)
		}
	}
}
</script>

<style scoped src="../assets/css/location_master.css"></style>
<style scoped src="../assets/css/list_table.css"></style>